/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'book': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M35 16.8v-1.323s-2.292-1.328-5.74-1.328c-3.448 0-5.26 1.25-5.26 1.25s-1.813-1.25-5.26-1.25c-3.448 0-5.74 1.328-5.74 1.328V16.8l-1 .531v15.708s4.531-1.578 6.999-1.578 5.001.885 5.001.885 2.532-.885 5-.885c.306 0 .643.024 1 .066v4.325l1.531-2.016L33 35.852v-3.72c2 .43 3 .906 3 .906V17.331l-1-.531zM23 29.03c-1-.292-2.584-.679-3.981-.679-2.246 0-3.019.404-4.019.699V16.634s1.125-.699 4.019-.699c1.694 0 2.981.417 3.981 1.126V29.03zm10 .021c-1-.295-1.773-.699-4.02-.699-1.396 0-2.981.387-3.98.679V17.06c1-.709 2.286-1.126 3.98-1.126 2.895 0 4.02.699 4.02.699v12.418z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/book.js